"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  de: {
    reactMuiTables: {
      selected: 'ausgewählt',
      filterhide: 'Filter verstecken',
      filtershow: 'Filter zeigen',
      refresh: 'erneuern',
      filter: {
        actions: {
          search: 'Suchen',
          resetFilter: 'Filter zurücksetzen',
          addCondition: 'Bedingung hinzufügen'
        }
      },
      standardOperators: {
        equals: 'gleich',
        contains: 'beinhaltet',
        between: {
          label: 'zwischen',
          from: 'von',
          to: 'bis'
        },
        oneOf: 'ein von'
      },
      labelRowsPerPage: 'Zeilen pro Seite:'
    }
  }
};
var _default = messages;
exports.default = _default;